import React from 'react';

interface Props {
  className?: string;
}
export default function PlayIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 6.74101C7 5.96922 7.83721 5.48835 8.50387 5.87723L17.5192 11.1362C18.1807 11.5221 18.1807 12.4779 17.5192 12.8637L8.50387 18.1227C7.83721 18.5116 7 18.0307 7 17.2589L7 6.74101Z"
        fill="currentColor"
      />
    </svg>
  );
}
